<template>
    <form ref="form" method="POST" action="https://www.liqpay.ua/api/3/checkout" accept-charset="utf-8">
        <input
            type="hidden"
            name="data"
            :value="data"
        />
        <input
            type="hidden"
            name="signature"
            :value="signature"
        />
    </form>
</template>

<script>
    export default {
        name: 'LiqpayForm',
        props: {
            data: {
                required: true,
                type: String,
            },
            signature: {
                required: true,
                type: String,
            },
        },
        computed: {
            valid() {
                return this.data && this.signature;
            },
        },
        mounted() {
            if (this.valid) {
                this.$refs.form.submit();
            }
        },
    }
</script>

<style scoped>

</style>
